import React, { Suspense } from 'react';
import { useParams } from 'react-router-dom';

import { SettingsPageFrame, TableSkeleton } from '@eluve/blocks';

import { SessionTypesTable } from './SessionTypesTable';

export const SessionTypesPage: React.FC = () => {
  const { tenantId } = useParams() as { tenantId: string };

  return (
    <SettingsPageFrame size="wide" title="Session Types">
      <Suspense fallback={<TableSkeleton rowCount={10} />}>
        <SessionTypesTable tenantId={tenantId} />
      </Suspense>
    </SettingsPageFrame>
  );
};
